export const topLocations = (foo, arr) => {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].name === foo) {
      const a = arr.splice(i, 1)
      arr.unshift(a[0])
      break
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/top-locations-helper.ts